const MSG_TYPES = {
  ERROR: 'ERROR'
}

const BASE_URL = window.Shopify.routes.root

const messageGenerator = (type, data) => {
  return {
    type, data
  }
}

const addItemsToCart = async ({variant, pattern, text, font }) => {
  const formData = {
    items: [{
      ...variant,
      properties: {
        pattern,
        message: text,
        font
      }
    }]
  }
  try {
    const response = await fetch(`${BASE_URL}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    const responseJson = await response.json()
    if(responseJson['items']!==undefined){
      window.location = '/cart'
    }
    return responseJson
  } catch (e) {
    console.log(e)
    return {error: 'Unable to add item to cart '}
  }

}
const fetchCollectionItems = async ({collection = 'customprintfonts'}) => {
  try {
    const response = await fetch(`${BASE_URL}collections/${collection}/products.json`)
    return response.json()
  } catch (e) {
    return {error: 'Unable to fetch collections'}
  }
}

const EVENTS = Object.freeze({
  ADD_ITEM_TO_CART: 'ADD_ITEM_TO_CART',
  FETCH_COLLECTION: 'FETCH_COLLECTION'
})
const EVENT_HANDLER_MAP = {
  [EVENTS.ADD_ITEM_TO_CART]: addItemsToCart,
  [EVENTS.FETCH_COLLECTION]: fetchCollectionItems
}

window.addEventListener("message", async (event) => {
  // Do we trust the sender of this message?  (might be
  // different from what we originally opened, for example).
  if (event.origin !== "https://customfont.shopmannythings.com")
    return;

  const {type = null, data = {}} = event?.data || {}

  const handler = EVENT_HANDLER_MAP[type]

  if (handler === undefined) {
    return event.source.postMessage(
      messageGenerator(type || MSG_TYPES.ERROR, {error: 'No Handler Defined'}), event.origin
    );
  }

  const messageResponse = await handler(data)

  console.log(messageResponse)

  return event.source.postMessage(
    messageGenerator(type, messageResponse), event.origin
  );


  // event.source is popup
  // event.data is "hi there yourself!  the secret response is: rheeeeet!"
}, false);